import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { ITeamMast, Table } from "./Table";
import { EmptyTeam, TeamData, teamData } from "./EmptyTenderTeam";
import { IPermissionProps } from "../../../models/Login";
import { TenderTeamMemberForm } from "./TenderTeamMemberForm";
import { ITenderTeamManagement } from "../../../models/TenderTeamManagment";

export interface IModel {
    open: boolean,
    singleData: ITenderTeamManagement,
    teamNameList: ITeamMast[]
}

export interface IModel2 {
    open: boolean,
    singleData: teamData
}

export interface IModel3 {
    open: boolean,
    singleData: teamData[],
    inTeam: teamData,
}

export const TenderTeamManagementt = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTeam, open: false, teamNameList: [] } as IModel);
    const [modal2,setModal2] = useState({ singleData: TeamData, open: false } as IModel2);
    const [modal3,setModal3] = useState({ singleData: [], open: false, inTeam:{} } as IModel3);
    const [reload, setReload] = useState(false);
    const [reload2, setReload2] = useState(false);
    const [reload3, setReload3] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyTeam, open: false, teamNameList: [] })
    };
    const hideDialog2 = () => {
        setModal2({ singleData: TeamData, open: false })
    };
    const hideDialog3 = () => {
        setModal3({ singleData: [], open: false, inTeam: TeamData })
    };

    return (
        <>
             <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} teamNameList={modal.teamNameList}></Form>
            <TenderTeamMemberForm singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={toast} reload={reload2} setReload={setReload2} setModal={setModal} setModal3={setModal3}></TenderTeamMemberForm>
            <TenderTeamMemberForm singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog3} toast={toast} reload={reload3} setReload={setReload3} inTeam={modal3.inTeam} setModal3={setModal2}></TenderTeamMemberForm>
            <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}